// extracted by mini-css-extract-plugin
module.exports = {"modal-box":"iA","modalBox":"iA","modal-mask":"iB","modalMask":"iB","close-btn":"iC","closeBtn":"iC","container":"iD","content":"iE","title":"iF","subTitle":"iG","detail":"iH"};